import React from 'react';
import { Checkbox } from 'antd';
import { useFormikContext } from 'formik';
import { FormFieldWrapper } from './FormFieldWrapper';
import { FieldInfoMessage } from './FieldInfoMessage';

export const CheckboxField = ({ name, label, disabled, infoMessage, required }: any) => {
  const { handleChange, values } = useFormikContext<any>();
  return (
    <FormFieldWrapper name={name} label={``} required={required}>
      <Checkbox
        name={name}
        checked={values[name]}
        onChange={handleChange}
        disabled={disabled}
      >
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </Checkbox>
      {infoMessage && <FieldInfoMessage message={infoMessage} />}
    </FormFieldWrapper>
  );
};
